﻿import React, { useRef, useCallback, useEffect } from 'react';
import { useDrag } from '@Util/useDrag';
import { Popup_Props } from '@Util/Types';

import Header from '@Elements/Popup/Header';

const Popup: React.FC<Popup_Props> = (props) => {
    const draggableRef = useRef<HTMLDivElement | null>(null);
    const { position, handleMouseDown } = useDrag({ ref: draggableRef, dialogOpen: props.open });

    const createPopupClass = useCallback(() => {
        return `Popup${props.open ? ' Popup--Active' : ''}`;
    }, [props.open]);

    const handleCloseAction = useCallback(() => {
        if (!props.disable_close_action) {
            props.set_open(false);
        }
    }, [props.disable_close_action, props.set_open]);

    // CLOSES POPUP WITH ESC
    useEffect(() => {
        if (!props.open) return;

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                handleCloseAction();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [props.open, handleCloseAction]);

    return (
        <div className={createPopupClass()}>
            <div
                className="Popup_Inner"
                ref={draggableRef}
                style={{
                    transform: position ? `translate(${position?.x ?? 0}px, ${position?.y ?? 0}px)` : undefined
                }}
            >
                <Header
                    handle_mouse_down={handleMouseDown}
                    title={props.title}
                    set_open={props.set_open}
                    disable_close_action={props.disable_close_action}
                    on_close_action={handleCloseAction}
                />
                <article className="Popup_Content">
                    {props.children}
                </article>
            </div>
        </div>
    );
};

export default Popup;